import { Fragment } from 'vue-fragment';

import strings from '../strings.json';
import store from '../store';

class TranslateManager {
  key = "$translate_lang";
  supported = ["EN", "KO"];

  init() {
    var lang = localStorage.getItem(this.key);

    if (this.isSupported(lang))
    {
      this.change(lang, false);
    }
    else
    {
      lang = navigator.language || navigator.userLanguage;
      lang = lang.toUpperCase();
      lang = lang.substring(0, 2);

      if (!this.isSupported(lang))
        lang = this.supported[0];

      this.change(lang, false);
    }
  }

  isSupported(lang)
  {
    return this.supported.findIndex(v => v == lang) > -1;
  }

  change(lang, save = true) {
    if (!this.isSupported(lang))
      lang = this.supported[0];

    store.state.lang = lang;

    if (save)
      localStorage.setItem(this.key, lang);
  }
}

const translateManager = new TranslateManager();

String.prototype.format = function() {
  let args = arguments;

  return args[0].replace(/{(\d+)}/g, function(match, num) {
    num = Number(num) + 1;
    return typeof(args[num]) != undefined ? args[num] : match;
  });
}

String.prototype.t = function() {
  let args = arguments;

  if (args.length == 0)
  {
    var langKey = `${this}_${store.state.lang}`;
    if (store.state.lang == "EN" || !strings[langKey])
      langKey = this;
    return strings[langKey] ? strings[langKey] : this;
  }

  return "".format(this.t(), ...args);
}

var getChildrenTextContent = function (children) {
  return children.map(function (node) {
    return node.children
      ? getChildrenTextContent(node.children)
      : node.text
  }).join('')
}

export default function install ( Vue, _ ) {
  Object.defineProperty( Vue.prototype, '$translateManager', {
      get() { return translateManager }
  });

  Vue.component('trans', {
    functional: true,
    props: ['t', 'wrap'],
    render(createElement, context) {
        var children = [];

        context.props.t.t().replace(/{(\d+)}/g, (match, p1, p2, s) => {
          p1 = parseFloat(p1);
          if (context.children[p1] != undefined)
          {
            if (p1 == 0)
            {
              var ss = s.substr(0, p2);
              if (ss)
                children.push(createElement('span', ss));
            }
            else
            {
              var ss = s.substring(s.indexOf(`{${p1 - 1}}`) + 3, p2);
              if (ss)
                children.push(createElement('span', ss));
            }

            children.push(context.children[p1]);

            if (!context.children[p1 + 1])
              children.push(createElement('span', s.substr(p2 + 3)));
          }
        });

        if (children.length == 0)
          children.push(createElement('span', context.props.t.t()));
        else if (context.props.wrap)
        {
          children = children.map(x => {
            if (x.tag == 'br')
              return x;

            return createElement(context.props.wrap, { class: "wrap" }, [x]);
          });

          children = children.map(x => {
            if (!x.children)
              return x;

            var text = getChildrenTextContent(x.children);
            const spacing = [];

            if (text[0] == ' ')
              spacing.push(' ');

            spacing.push(x);

            if (text[text.length - 1] == ' ')
              spacing.push(' ');
            
            return createElement(Fragment, spacing);
          });
        }

        return createElement(Fragment, children);
    }
});
};



// WEBPACK FOOTER //
// ./src/managers/TranslateManager.js